import { IItinerary } from "@thekilroygroup/shared-ui";

export const isRoundNumber = (number: number) => {
  return number - Math.floor(number) === 0;
};

export const getCurrency = (itinerary: IItinerary) => {
  return itinerary.totalFareAmounts.currency;
};
